<h2 class="form-title">{{ titleName }}</h2>

@if (loadingItems) {
<div class="loading">
  <app-loading-indicator />
</div>
}

<form
  (ngSubmit)="onSubmit()"
  [class.disabled]="loadingItems"
  id="addPlaylistForm"
>
  <div class="control" id="nameControl">
    <label for="name">Name</label>
    <input
      class="form-control"
      type="text"
      id="name"
      name="name"
      [(ngModel)]="enteredName"
    />
  </div>

  <div class="control" id="selectedItems">
    <label for="selectedItems">Items</label>
    <p-multiSelect
      name="selectedItems"
      autoWidth="false"
      [style]="{ width: '100%' }"
      appendTo="body"
      [options]="availableItems"
      [(ngModel)]="selectedItems"
      (onClick)="onSelectedItemsDropdownClick($event)"
      display="chip"
      placeholder="Select Items"
      id="selectedItemsDropdown"
      optionLabel="ProgramName || TargetName"
      [filter]="true"
      filterBy="ProgramName,TargetName"
    >
      <ng-template let-value pTemplate="selectedItems">
        <div
          class="inline-flex align-items-center gap-2 px-1"
          *ngFor="let option of value"
        >
          <div>{{ option.ProgramName ?? option.TargetName }},</div>
          <p-tag
            *ngIf="isSelectedItemSubtarget(option)"
            severity="warning"
            value="Sub-target"
            class="subtarget-program-warning-badge"
            role="button"
            tabindex="0"
            aria-label="Show sub-target warning details"
            [pTooltip]="subtargetProgramWarningTooltip"
            tooltipPosition="top"
            (click)="toggleSubtargetProgramWarning($event, option)"
            (keydown.enter)="toggleSubtargetProgramWarning($event, option)"
            (keydown.space)="toggleSubtargetProgramWarning($event, option)"
          />
        </div>
        <div *ngIf="!value || value.length === 0">Select Items</div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex align-items-center gap-2">
          <div>{{ item.ProgramName ?? item.TargetName }}</div>
          <p-tag
            *ngIf="isSelectedItemSubtarget(item)"
            severity="warning"
            value="Sub-target"
            class="subtarget-program-warning-badge"
            role="button"
            tabindex="0"
            aria-label="Show sub-target warning details"
            [pTooltip]="subtargetProgramWarningTooltip"
            tooltipPosition="top"
            (click)="toggleSubtargetProgramWarning($event, item)"
            (keydown.enter)="toggleSubtargetProgramWarning($event, item)"
            (keydown.space)="toggleSubtargetProgramWarning($event, item)"
          />
        </div>
      </ng-template>
      <ng-template let-country pTemplate="footer">
        <div class="py-2 px-3">
          <b>
            {{ selectedItems().length }}
          </b>
          item{{ selectedItems().length > 1 ? "s" : "" }}
          selected.
        </div>
      </ng-template>
    </p-multiSelect>

    <p-overlayPanel
      #subtargetProgramWarningOp
      [showCloseIcon]="true"
      [dismissable]="true"
      [style]="{ width: '22rem' }"
      styleClass="subtarget-program-warning-panel"
    >
      <div class="subtarget-program-warning-content">
        <p class="mb-2">
          This target will not appear for use because it is a sub-target. Remove
          it from its parent if you want to use it individually.
        </p>
        @if (subtargetWarningTarget) {
          @if (getParentTargetFor(subtargetWarningTarget); as parentTarget) {
          <button
            type="button"
            class="btn btn-link p-0 subtarget-program-warning-link"
            (click)="editParentTargetFromWarning($event)"
          >
            Edit parent: {{ parentTarget.TargetName }}
          </button>
          }
        }
      </div>
    </p-overlayPanel>
  </div>

  <div class="control" id="addPlaylistDetails">
    <label for="details">Playlist Instructions</label>

    <div class="editor-container editor-container_classic-editor">
      <div class="editor-container__editor">
        <div>
          <ckeditor
            id="details"
            name="details"
            [editor]="Editor"
            [config]="editorConfig"
            [data]="currentPlaylist?.Details ?? ''"
            (change)="onDetailsChange($event)"
          ></ckeditor>
        </div>
      </div>
    </div>
  </div>

  <div class="control">
    <label for="orderedItems">Selected Items</label>
    <div
      cdkDropList
      class="example-list"
      (cdkDropListDropped)="drop($event)"
      id="itemsOrdering"
    >
      @for (item of selectedItems(); track item) {
      <div class="example-box" cdkDrag>
        {{ item.ProgramName ?? item.TargetName }}
      </div>
      }
    </div>
  </div>

  <div class="actions d-flex justify-content-between" id="playlistActions">
    <button class="w-100 mx-2" type="button" (click)="onCancel()">
      Cancel
    </button>
    <button class="w-100 mx-2" type="submit" id="savePlaylistButton">
      {{ actionName }}
    </button>
  </div>
  <div class="control" *ngIf="sharedSparkModeOptions.length > 0">
    <label>Also available in:</label>
    <p-multiSelect [options]="sharedSparkModeOptions" [(ngModel)]="sharedSparkModeIds"
      [ngModelOptions]="{standalone: true}" optionLabel="label" optionValue="value"
      display="chip" appendTo="body" placeholder="Only this mode" [style]="{width: '100%'}" />
  </div>
</form>
